"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCarouselPullQuoteItems = exports.renderCarouselImageItems = exports.imageSizes = void 0;
var _react = _interopRequireDefault(require("react"));
var _BoundedCard = _interopRequireDefault(require("../BoundedCard/BoundedCard"));
var _UnboundedCard = require("../UnboundedCard/UnboundedCard");
var _BioBlock = _interopRequireDefault(require("../BioBlock/BioBlock"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _PullQuote = _interopRequireDefault(require("../PullQuote/PullQuote"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Images Sizes here are the same when used in Bounded Cards, Unbounded Cards and Bio Blocks to preserve the 3:2 image ratio
const imageSizes = {
  desktop: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  tablet: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  mobile: {
    width: 525,
    height: 350,
    ratio: {
      width: 3,
      height: 2
    }
  }
};
exports.imageSizes = imageSizes;
const renderCarouselImageItems = content => {
  if (content?.images && content?.images?.length > 0) {
    return content?.images?.map((image, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-item",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
        focalPointImage: image?.focalPointImage,
        alt: image?.focalPointImage?.title,
        fullHeightWrapper: false,
        imageSizes: imageSizes
      }));
    });
  }
};
exports.renderCarouselImageItems = renderCarouselImageItems;
const renderCarouselPullQuoteItems = (content, height) => {
  if (content?.quotes && content?.quotes?.length > 0) {
    return content?.quotes?.map((pullQuote, index) => {
      const isTopImage = pullQuote?.topImage?.focalPointImage?.url || pullQuote?.topImage?.src ? true : false;
      const isSideImage = pullQuote?.sideImage?.focalPointImage?.url || pullQuote?.sideImage?.src ? true : false;
      const variant = () => {
        if (isSideImage && !isTopImage) {
          if (pullQuote?.imageOptions === "1/2") {
            return "variant2";
          } else if (pullQuote?.imageOptions === "1/4") {
            if (pullQuote?.appearance === "Light") {
              return "variant1";
            }
            if (pullQuote?.appearance === "Dark") {
              return "variant2";
            }
          } else if (pullQuote?.imageOptions === "No Image") {
            if (pullQuote?.appearance === "Light") {
              return "variant1";
            }
            if (pullQuote?.appearance === "Dark") {
              return "variant2";
            }
          } else {
            return "";
          }
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-item",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_PullQuote.default, {
        content: pullQuote,
        variant: variant(),
        height: height
      }));
    });
  }
};
exports.renderCarouselPullQuoteItems = renderCarouselPullQuoteItems;